import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const ChevronDownS2: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={24}
      height={24}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <g>
        <path
          d='m8.73 11.14l3 3 3-3'
          stroke='currentColor'
          strokeMiterlimit='10'
          strokeWidth='1.5'
        />
      </g>
    </svg>
  </i>
);

ChevronDownS2.displayName = 'ChevronDownS2';
export default ChevronDownS2;
